import { atom } from 'recoil';

export interface ISummaryRow {
	id: string;
	label: string;
	value: number;
}

export interface IDashboardData {
	title?: string;
	summary: {
		email: ISummaryRow[];
		session: ISummaryRow[];
		onboarding: ISummaryRow[];
	};
	chartData: {
		title: string;
		XAxis: string[];
		data: { name: string; data: number[] }[];
	};
}

export interface IDashboardsAtom {
	loaded: boolean;
	error: boolean;
	data: IDashboardData;
}

/**
 * /onboarding-summary, primed once at app mount by routes-children.
 * Read by the Ops Deck, hooks/allowed-invites, views/pipelines and
 * settings/billing — do not scope it to the dashboard.
 *
 * The default series list used to be hand-written with six named entries and
 * zero-filled arrays. Nothing needed the placeholder: every consumer reads
 * through `?? []`, and a fake "KYC: [0,0,0,0,0,0,0]" renders as a real flat
 * week until the response lands.
 */
export const DashboardsAtom = atom<IDashboardsAtom>({
	key: 'dashboard-atom-key',
	default: {
		loaded: false,
		error: false,
		data: {
			summary: { email: [], session: [], onboarding: [] },
			chartData: { title: '', XAxis: [], data: [] },
		},
	},
});

export type ActivityActionType =
	| 'kyc'
	| 'kyb'
	| 'aml'
	| '506b'
	| '506c'
	| 'payIn'
	| 'payOut'
	| 'signAgreement';
